import { observable, action, toJS } from "mobx";
import * as API_TABLE from "../apis/table";
import { Modal, message } from "antd";
import isFunction from "lodash/isFunction";
import uniqueId from "lodash/uniqueId";
import TestData from "./test-data.js";

export default class TableStore {
  @observable
  dataKey = "";
  @observable
  requireTimes = 0;
  @observable
  loading = false;
  @observable
  datas = [];
  @observable
  columns = [];
  @observable
  operates = [];
  @observable
  sortParams = [];
  @observable
  selectedRowKeys = [];
  @observable
  selectedUniqueIds = [];
  @observable
  showCheck = false;
  @observable
  pageAutoWrap = false;
  @observable
  rowstylefield = "";
  // 分页所有选中 keys
  @observable
  selectedRowKeysAllPages = [];
  // pagination
  @observable
  count = 0;
  @observable
  current = 1;
  @observable
  pageSize = 10;
  // 自定义列
  @observable
  colSetVisible = false;
  @observable
  colSetdatas = [];
  @observable
  colSetKeys = [];
  @observable
  rootMap = undefined;
  @observable
  browser = [];
  @observable
  isSts = false;
  @observable
  stsAllData = undefined;
  @observable
  stsData = undefined;
  @observable
  stsDatas = undefined;
  @observable
  rowCheckKey = []; // 当前选中行的key
  checkId = "";
  getDatasCallback = () => {};
  dataHandle = undefined; // 处理data
  @observable
  uniqueId = false; // 是否使用唯一id
  rowKey = null;
  @observable
  shouldRender = true;
  @observable
  component = null;
  expiredRefreshCount = 0;
  expiredRefreshFun = null;

  constructor(props) {
    if (props) {
      props.getDatasCallback &&
        (this.getDatasCallback = props.getDatasCallback);
      props.dataHandle && (this.dataHandle = props.dataHandle);
    }
    this.tableUpdate = this.tableUpdate.bind(this);
    this.getDatas = this.getDatas.bind(this);
    this.setSelectedRowKeys = this.setSelectedRowKeys.bind(this);
    this.tableColSet = this.tableColSet.bind(this);
    this.setColSetVisible = this.setColSetVisible.bind(this);
  }

  @action
  changeShouldRender(bool) {
    this.shouldRender = bool;
  }

  /**
   * 在 store 中获取当前 table实例
   */
  @action
  forceUpdate(self) {
    if (self) {
      this.component = self;
    }
    if (this.component) {
      this.component.forceUpdate();
    }
  }

  @action
  tableUpdate(object, isPending) {
    // isPending 刷新数据进程中清空的选中key 不进行当前页数据的过滤，数据为旧，并非取消当前页选中。
    if (Object.prototype.toString.call(object) === "[object Object]") {
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          if (key == "datas" && isFunction(this.dataHandle)) {
            this[key] = this.dataHandle(object[key]);
          } else if (
            key === "selectedRowKeys" ||
            key === "selectedRowKeysAllPages"
          ) {
            const sKeys = toJS(this.selectedRowKeys);
            const sKeysAll = toJS(this.selectedRowKeysAllPages);
            const datas = object.datas || (isPending ? [] : toJS(this.datas));
            if (key === "selectedRowKeys") {
              this.selectedRowKeysAllPages = sKeysAll
                .filter(
                  k =>
                    !datas.some(
                      (d, i) =>
                        (this.rowKey ? this.rowKey(d, i) : d.randomFieldId) ===
                        k
                    )
                )
                .concat(object[key]);
              // console.log(toJS(this.selectedRowKeysAllPages));
            }
            if (key === "selectedRowKeysAllPages") {
              this.selectedRowKeys = object[key].filter(k =>
                datas.some((d, i) => {
                  const getKey = this.rowKey
                    ? this.rowKey(d, i)
                    : d.randomFieldId;
                  return getKey === k;
                })
              );
              // console.log(toJS(this.selectedRowKeys));
            }
            this[key] = object[key];
          } else if (key === "sortParams") {
            if (object[key].length !== 0) {
              this[key] = object[key];
            }
          } else {
            this[key] = object[key];
          }
        }
      }
    }
    return this;
  }

  @action
  getDatas(
    sessionkey,
    currentNow,
    pageSizeNow,
    sorter = "",
    callback = this.getDatasCallback,
    clearSelectedRowKeysAllPages = true
  ) {
    const requireTimes = this.requireTimes;
    // 初始化table && 清理部分状态
    const allPagesObj = clearSelectedRowKeysAllPages
      ? { selectedRowKeysAllPages: [] }
      : {};
    this.tableUpdate(
      {
        loading: true,
        selectedRowKeys: [],
        requireTimes: requireTimes + 1,
        ...allPagesObj
      },
      true
    );
    // 已初始化
    const dataKey = sessionkey || this.dataKey;
    const pageSizeChange = pageSizeNow && pageSizeNow != this.pageSize;
    const pageSize = pageSizeNow || this.pageSize;
    const current = pageSizeChange ? 1 : currentNow || this.current;
    const sortParams =
      sorter && sorter.column
        ? [{ orderkey: sorter.column.orderkey, sortOrder: sorter.order }]
        : Array.isArray(sorter)
        ? sorter
        : [];
    if (sorter !== "") {
      this.sortParams = sortParams;
    }
    this.tableUpdate({
      dataKey,
      current,
      pageSize
      // datas: []
    });
    const doGetAPI = () => {
      API_TABLE.getTableDatas({
        dataKey,
        current,
        // sortParams: JSON.stringify(sortParams)
        sortParams: JSON.stringify(toJS(this.sortParams))
      })
        .then(
          action(data => {
            // data = {"pageAutoWrap":true,"ops":[{"otherpara":"313897+1+285578+-8458","nodeName":"popedom","async":"false","otherpara2":"","transmethod":"com.api.cube.util.CubeSearchTransMethodProxy.getSearchResultOperation"},{"otherpara":"","nodeName":"operate","index":"1","href":"javascript:qq","text":"teaets"}],"isSts":false,"columns":[{"belong":"0","_index":0,"isInputCol":"false","display":"true","dbField":"id","className":"","isPrimarykey":"true","title":"数据ID","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"id","showType":"0","fixed":"left","oldWidth":"50.0px","transMethodOther":"column:id+-3+4+5+7+1+3+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++2+false"},{"belong":"0","_index":1,"isInputCol":"false","display":"true","dbField":"zdydx","className":"","isPrimarykey":"false","title":"自定义单选","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"zdydx","showType":"0","fixed":"left","oldWidth":"50.0px","transMethodOther":"column:id+693807+3+161+7+1+browser.cykzllk190601+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":2,"isInputCol":"false","display":"true","dbField":"dwb","className":"","isPrimarykey":"false","title":"多文本","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"dwb","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693808+2+1+7+1+varchar2(4000)+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":3,"isInputCol":"false","display":"true","dbField":"xzk","className":"","isPrimarykey":"false","title":"选择框","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"xzk","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693809+5+1+7+1+int+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":4,"isInputCol":"false","display":"true","dbField":"sj","className":"","isPrimarykey":"false","title":"时间","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"sj","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693810+3+19+7+1+char(5)+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":5,"isInputCol":"false","display":"true","dbField":"zdydx2","className":"","isPrimarykey":"false","title":"自定义多选","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"zdydx2","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693811+3+162+7+1+browser.cykzllk190601+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":6,"isInputCol":"false","display":"true","dbField":"sdx","className":"","isPrimarykey":"false","title":"树单选","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"sdx","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693812+3+256+7+1+99923+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":7,"isInputCol":"false","display":"true","dbField":"jezh","className":"","isPrimarykey":"false","title":"金额转换","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"jezh","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693813+1+4+7+1+number(15,2)+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":8,"isInputCol":"false","display":"true","dbField":"sxdx","className":"","isPrimarykey":"false","title":"树形多选","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"sxdx","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693814+3+257+7+1+99923+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":9,"isInputCol":"false","display":"true","dbField":"qfw","className":"","isPrimarykey":"false","title":"千分位","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"qfw","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693815+1+5+7+1+varchar2(30)+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++2+false"},{"belong":"0","_index":10,"isInputCol":"false","display":"true","dbField":"dwbhtml","className":"customWrap","isPrimarykey":"false","title":"多文本html","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"dwbhtml","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693816+2+2+7+1+varchar2(4000)+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":11,"isInputCol":"false","display":"true","dbField":"zs","className":"","isPrimarykey":"false","title":"整数","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"zs","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693817+1+2+7+1+int+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":12,"isInputCol":"false","display":"true","dbField":"fds","className":"","isPrimarykey":"false","title":"浮点数","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"fds","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693818+1+3+7+1+number(38,2)+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++2+false"},{"belong":"0","_index":13,"isInputCol":"false","display":"true","dbField":"wb2","className":"","isPrimarykey":"false","title":"文本2","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"wb2","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693819+1+1+7+1+varchar2(700)+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":14,"isInputCol":"false","display":"true","dbField":"wb1","className":"","isPrimarykey":"false","title":"文本1","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"wb1","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693820+1+1+7+1+varchar2(700)+1+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":15,"isInputCol":"false","display":"true","dbField":"rq","className":"","isPrimarykey":"false","title":"日期","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethod.getOthers","dataIndex":"rq","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:id+693821+3+2+7+1+char(10)+0+285578+-8458+0+0+0+313897+fromsearchlist+0+1+0++0+false"},{"belong":"0","_index":16,"isInputCol":"false","display":"true","dbField":"modedatacreatedate","className":"","isPrimarykey":"false","title":"创建日期","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethodProxy.getSearchResultCreateTime","dataIndex":"modedatacreatedate","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:modedatacreatetime+313897+0+column:id+-8458"},{"belong":"0","_index":17,"isInputCol":"false","display":"true","dbField":"modedatacreater","className":"","isPrimarykey":"false","title":"创建人","hide":"false","transMethod":"com.api.cube.util.CubeSearchTransMethodProxy.getSearchResultName","dataIndex":"modedatacreater","showType":"0","fixed":"none","oldWidth":"50.0px","transMethodOther":"column:modedatacreatertype"},{"dataIndex":"randomFieldId","dbField":"randomFieldId","from":"set","title":"randomFieldId"}],"datas":[{"jezhspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","qfw":"","zdydx":"","dwbhtmlspan":"<span></span>","idspan":"3","sdx":"95703_2","wb2":"","xzkspan":"C","zdydx2":"","wb1":"测试2","sxdxspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","sxdx":"","dwbhtml":"","modedatacreaterspan":"<a href=javaScript:openhrm(1) onclick=\"pointerXY(event)\">系统管理员</a>","fdsspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","modedatacreatedatespan":"2019-07-02 10:46:27","modedatacreatedate":"2019-07-02","sj":"10:45","jezh":"","randomFieldIdspan":"","id":"3","dwbspan":"<span></span>","wb2span":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","xzk":"2","sjspan":"10:45","zdydx2span":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","dwb":"","modedatacreater":"1","sdxspan":"<a  href=javascript:modeopenFullWindowHaveBar('/spa/cube/index.html#/main/cube/anyurl?pid=95703_2') title='特级一等'>特级一等</a>&nbsp","fds":"","zdydxspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","wb1span":"<a title='测试2' href=javascript:void(0) onclick='javascript:openHref(\"/spa/cube/index.html#/main/cube/card?type=0&modeId=285578&formId=-8458&billid=3&opentype=0&customid=313897&viewfrom=fromsearchlist\");'>测试2</a> ","zs":"","zsspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","qfwspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","randomFieldId":"3","rqspan":"2019-07-02","rq":"2019-07-02"},{"jezhspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","qfw":"","zdydx":"","dwbhtmlspan":"<span></span>","idspan":"2","sdx":"95703_1","wb2":"","xzkspan":"B","zdydx2":"","wb1":"测试2","sxdxspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","sxdx":"","dwbhtml":"","modedatacreaterspan":"<a href=javaScript:openhrm(1) onclick=\"pointerXY(event)\">系统管理员</a>","fdsspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","modedatacreatedatespan":"2019-07-02 10:43:58","modedatacreatedate":"2019-07-02","sj":"10:43","jezh":"","randomFieldIdspan":"","id":"2","dwbspan":"<span></span>","wb2span":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","xzk":"1","sjspan":"10:43","zdydx2span":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","dwb":"","modedatacreater":"1","sdxspan":"<a  href=javascript:modeopenFullWindowHaveBar('/spa/cube/index.html#/main/cube/anyurl?pid=95703_1') title='特级'>特级</a>&nbsp","fds":"","zdydxspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","wb1span":"<a title='测试2' href=javascript:void(0) onclick='javascript:openHref(\"/spa/cube/index.html#/main/cube/card?type=0&modeId=285578&formId=-8458&billid=2&opentype=0&customid=313897&viewfrom=fromsearchlist\");'>测试2</a> ","zs":"","zsspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","qfwspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","randomFieldId":"2","rqspan":"2019-07-02","rq":"2019-07-02"},{"jezhspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","qfw":"","zdydx":"1","dwbhtmlspan":"<span></span>","idspan":"1","sdx":"","wb2":"","xzkspan":"A","zdydx2":"3,6","wb1":"测试1","sxdxspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","sxdx":"","dwbhtml":"","modedatacreaterspan":"<a href=javaScript:openhrm(1) onclick=\"pointerXY(event)\">系统管理员</a>","fdsspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","modedatacreatedatespan":"2019-07-02 10:41:23","modedatacreatedate":"2019-07-02","sj":"10:40","jezh":"","randomFieldIdspan":"","id":"1","dwbspan":"<span></span>","wb2span":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","xzk":"0","sjspan":"10:40","zdydx2span":"<a title='特级二等' href=javascript:openHref(\"/spa/cube/index.html#/main/cube/card?type=0&modeId=285577&formId=-8459&billid=3\") >特级二等</a>&nbsp;<a title='高级一等' href=javascript:openHref(\"/spa/cube/index.html#/main/cube/card?type=0&modeId=285577&formId=-8459&billid=6\") >高级一等</a>&nbsp;","dwb":"","modedatacreater":"1","sdxspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","fds":"","zdydxspan":"<a title='特级' href=javascript:openHref(\"/spa/cube/index.html#/main/cube/card?type=0&modeId=285577&formId=-8459&billid=1\") >特级</a>&nbsp;","wb1span":"<a title='测试1' href=javascript:void(0) onclick='javascript:openHref(\"/spa/cube/index.html#/main/cube/card?type=0&modeId=285578&formId=-8458&billid=1&opentype=0&customid=313897&viewfrom=fromsearchlist\");'>测试1</a> ","zs":"22","zsspan":"22","qfwspan":"<div class='empty-columns' style=\"min-width:20px;min-height:20px\"></div>","randomFieldId":"1","rqspan":"2019-07-02","rq":"2019-07-02"}],"haveCheck":true,"rootMap":{"tabletype":"checkbox","counttransmethod":"true","pagesize":"10","pageUid":"mode_customsearch:313897","pageId":"mode_customsearch:313897","mobileshowtype":"listview"},"pageSize":"10","timeJson":{"read data in dao":1,"read data from datasource":0,"do browser":0,"last":0,"init Bean":1,"get current user and count page ":23,"all cost":160,"do transMethod in dao":135,"create sql":0},"mobileshowtype":"listview","status":true}
            // data.columns[0].fixed = 'left';
            // data.columns[0].oldWidth = '100px';
            const requireTimesNow = this.requireTimes;
            /**
             * 当 table 回调结束时，获取当前渲染状态决定是否需要更新。比如：
             * 外部 input 输入引发的 table 渲染不需要更新，内部 搜索，翻页等则需要更新
             */
            if (!this.shouldRender) {
              this.forceUpdate();
            }
            this.shouldRender = true;
            if (data.count === undefined) {
              API_TABLE.getTableCounts({ dataKey })
                .then(
                  action(data => {
                    const requireTimesNow = this.requireTimes;
                    if (
                      dataKey == this.dataKey &&
                      requireTimesNow === requireTimes + 1
                    ) {
                      this.tableUpdate({
                        count: data.count
                      });
                      return data;
                    }
                  })
                )
                .catch(
                  action(res => {
                    this.handleExpiredRefreshFun(res);
                  })
                );
            } else {
              this.tableUpdate({
                count: data.count
              });
            }
            if (
              dataKey == this.dataKey &&
              requireTimesNow === requireTimes + 1
            ) {
              if (this.uniqueId) {
                data.datas = data.datas.map(data => ({
                  ...data,
                  uniqueId: uniqueId(sessionkey)
                }));
              }
              // test
              // data.rootMap.tabletype = "checkbox";
              // data = TestData.data;
              this.tableUpdate({
                dataKey,
                loading: false,
                datas: data.datas,
                columns: data.columns,
                operates: data.ops,
                showCheck:
                  data.rootMap.tabletype == "checkbox" ||
                  data.rootMap.tabletype == "radio" ||
                  data.haveCheck,
                pageAutoWrap: data.pageAutoWrap,
                rowstylefield: data.rowstylefield,
                // pagination
                pageSize: data.pageSize,
                current,
                sortParams,
                rootMap: data.rootMap,
                browser: data.browser,
                isSts: data.isSts,
                stsAllData: data.stsAllData,
                stsData: data.stsData
              });
              isFunction(callback) && callback();
              return data;
            }
          })
        )
        .then(
          action(result => {
            if (result) {
              const { rootMap, ops } = result;
              if (
                rootMap.tabletype == "checkbox" ||
                rootMap.tabletype == "radio" ||
                (ops && ops.length > 0)
              ) {
                const { columns, datas } = result;
                const newDatas = [];
                datas.forEach(data => {
                  const newData = {};
                  columns.forEach(column => {
                    if (
                      (column.from && column.from === "set") ||
                      column.dataIndex === "randomFieldId"
                    ) {
                      newData[column.dataIndex] = data[column.dataIndex];
                    }
                  });
                  newDatas.push(newData);
                });
                API_TABLE.getTableChecks({
                  dataKey,
                  checkId: this.checkId,
                  randomDatas: JSON.stringify(newDatas)
                })
                  .then(
                    action(data => {
                      const requireTimesNow = this.requireTimes;
                      if (
                        dataKey == this.dataKey &&
                        requireTimesNow === requireTimes + 1
                      ) {
                        const resetDatas = datas.map(d => {
                          const _d = { ...d };
                          data.datas &&
                            data.datas.forEach(n => {
                              if (n.randomFieldId === d.randomFieldId) {
                                for (const p in n) {
                                  if (n.hasOwnProperty(p)) {
                                    _d[p] = n[p];
                                  }
                                }
                              }
                            });
                          return _d;
                        });
                        // 根据分页选中 key 需要重置当前页选中 key
                        this.tableUpdate({
                          datas: resetDatas,
                          selectedRowKeysAllPages: toJS(
                            this.selectedRowKeysAllPages
                          )
                        });
                      }
                    })
                  )
                  .catch(
                    action(res => {
                      this.handleExpiredRefreshFun(res);
                    })
                  );
              }
            }
          })
        )
        .catch(
          action(res => {
            this.handleExpiredRefreshFun(res);
          })
        );
    };
    pageSizeChange
      ? API_TABLE.setTablePageSize({
          dataKey,
          pageSize
        }).then(
          action(() => {
            doGetAPI();
          })
        )
      : doGetAPI();
    return this;
  }

  @action
  reloadCurrent = (callback = this.getDatasCallback) => {
    const { dataKey, current, pageSize, sortParams } = this;
    this.getDatas(dataKey, current, pageSize, toJS(sortParams), callback);
  };

  @action
  setSelectedRowKeys(selectedRowKeys = []) {
    if (this.uniqueId) {
      const usedRowKeys = [];
      const datas = toJS(this.datas);
      selectedRowKeys.forEach(key => {
        const data = datas.find(_data => _data.uniqueId === key);
        const index = datas.findIndex(_data => _data.uniqueId === key);
        if (data && index !== -1) {
          usedRowKeys.push(
            this.rowKey ? this.rowKey(data, index) : data.randomFieldId
          );
        }
      });
      this.tableUpdate({
        selectedUniqueIds: selectedRowKeys,
        selectedRowKeys: usedRowKeys
      });
    } else {
      this.tableUpdate({ selectedRowKeys });
    }
    return this;
  }

  @action
  setSelectedRowKeysAllPages(selectedRowKeysAllPages = []) {
    this.tableUpdate({ selectedRowKeysAllPages });
    return this;
  }

  // 给使用uniqueId的Table提供的设置选中行的方法。
  @action
  setNotUniqueSelectedRowKeys(selectedRowKeys) {
    const uniqueIds = [];
    toJS(this.datas).forEach((data, index) => {
      const rowKey = this.rowKey
        ? this.rowKey(data, index)
        : data.randomFieldId;
      if (selectedRowKeys.some(key => key == rowKey)) {
        uniqueIds.push(data.uniqueId);
      }
    });

    this.tableUpdate({
      selectedUniqueIds: uniqueIds,
      selectedRowKeys
    });
  }

  @action
  tableColSet(isInit, setColCB, isReset) {
    const { dataKey, colSetKeys } = this;
    const method = isInit ? "GET" : "POST";

    this.tableUpdate({ loading: true });

    API_TABLE.tableColSet(
      isInit
        ? {
            dataKey
          }
        : {
            dataKey,
            systemIds: isReset ? "" : `${colSetKeys.toJS()}`
          },
      method
    ).then(
      action(data => {
        if (data.status) {
          if (data.destdatas) {
            const keys = [];
            data.destdatas.forEach(d => {
              keys.push(d.dataIndex);
            });
            const datas = []
              .concat(data.destdatas)
              .concat(data.srcdatas)
              .filter(d => !!d.title && d.customCol != "false");
            const newDatas = [];
            datas.map(d =>
              newDatas.push({
                id: d.dataIndex,
                name: d.title,
                description: d.title
              })
            );
            this.tableUpdate({
              colSetKeys: keys,
              colSetdatas: newDatas,
              loading: false
            });
            setColCB && setColCB(keys, newDatas);
          } else {
            setColCB && setColCB(colSetKeys.toJS(), []);
            this.tableUpdate({
              colSetVisible: false,
              colSetKeys: [],
              loading: false
            });
            this.getDatas(dataKey);
          }
        } else {
          message.error("接口错误，请重新提交");
        }
      })
    );
    return this;
  }

  @action
  setTableColSetkeys(colSetKeys = []) {
    this.tableUpdate({ colSetKeys });
    return this;
  }

  @action
  setColSetVisible(colSetVisible = false) {
    this.tableUpdate({ colSetVisible });
    return this;
  }

  readAll = () => {
    this.dataKey;
    this.requireTimes;
    this.loading;
    this.datas;
    this.columns;
    this.operates;
    this.sortParams;
    this.selectedRowKeys;
    this.showCheck;
    this.pageAutoWrap;
    this.rowstylefield;
    // pagination
    this.count;
    this.current;
    this.pageSize;
    // 自定义列
    this.colSetVisible;
    this.colSetdatas;
    this.colSetKeys;
    this.rootMap;
    this.browser;
  };

  exportCurrent = (filetype = "", filename = "") => {
    let min =
        (Number(this.current) < 1 ? 1 : Number(this.current) - 1) *
          Number(this.pageSize) +
        1,
      max = min + Number(this.pageSize) - 1;
    // AndyZhang 添加自定义文件名功能
    if (filename != "") {
      const form = jQuery("<form>");
      form.attr("style", "display:none");
      form.attr("target", "");
      form.attr("method", "post");
      form.attr("action", "/api/ec/dev/table/export");

      const inputmin = jQuery("<input>");
      inputmin.attr("type", "hidden");
      inputmin.attr("name", "min");
      inputmin.attr("value", min);
      form.append(inputmin);

      const inputmax = jQuery("<input>");
      inputmax.attr("type", "hidden");
      inputmax.attr("name", "max");
      inputmax.attr("value", max);
      form.append(inputmax);

      const inputdataKey = jQuery("<input>");
      inputdataKey.attr("type", "hidden");
      inputdataKey.attr("name", "dataKey");
      inputdataKey.attr("value", this.dataKey);
      form.append(inputdataKey);

      const inputfiletype = jQuery("<input>");
      inputfiletype.attr("type", "hidden");
      inputfiletype.attr("name", "filetype");
      inputfiletype.attr("value", filetype);
      form.append(inputfiletype);

      const inputfilename = jQuery("<input>");
      inputfilename.attr("type", "hidden");
      inputfilename.attr("name", "filename");
      inputfilename.attr("value", filename);
      form.append(inputfilename);

      jQuery(document.body).append(form);
      form.submit();
    } else {
      API_TABLE.tableExport({
        dataKey: this.dataKey,
        min,
        max,
        filetype: this.filetype,
        filename: this.filename
      }).then(
        action(result => {
          window.location.href = result.url;
        })
      );
    }
  };

  exportAll = (filetype = "", filename = "", otherParams = {}) => {
    // AndyZhang 添加自定义文件名功能
    if (false && filename != "") {
      const form = jQuery("<form>");
      form.attr("style", "display:none");
      form.attr("target", "");
      form.attr("method", "post");
      form.attr("action", "/api/ec/dev/table/export");

      const inputdataKey = jQuery("<input>");
      inputdataKey.attr("type", "hidden");
      inputdataKey.attr("name", "dataKey");
      inputdataKey.attr("value", this.dataKey);
      form.append(inputdataKey);

      const inputfiletype = jQuery("<input>");
      inputfiletype.attr("type", "hidden");
      inputfiletype.attr("name", "filetype");
      inputfiletype.attr("value", filetype);
      form.append(inputfiletype);

      const inputfilename = jQuery("<input>");
      inputfilename.attr("type", "hidden");
      inputfilename.attr("name", "filename");
      inputfilename.attr("value", filename);
      form.append(inputfilename);

      jQuery(document.body).append(form);
      form.submit();
    } else {
      if (filename == "") {
        filetype = "";
      }
      API_TABLE.tableExport({
        dataKey: this.dataKey,
        filetype,
        filename,
        ...otherParams
      }).then(
        action(result => {
          window.location.href = result.url;
          // 清除临时文件接口
          // const arr = result.url.split("/");
          // API_TABLE.cleartemp({ filename: arr[arr.length - 1] }).then(
          //   res => {}
          // );
        })
      );
    }
  };

  @action
  setRowCheckKey = (rowCheckKey = []) => {
    this.rowCheckKey = rowCheckKey;
  };

  @action
  injectExpiredRefreshFun(fun) {
    this.expiredRefreshFun = fun;
  }

  @action
  handleExpiredRefreshFun(res) {
    if (typeof this.expiredRefreshFun === "function") {
      while (this.expiredRefreshCount < 1) {
        this.expiredRefreshFun(res);
        this.expiredRefreshCount++;
      }
    } else {
      console.warn(
        "===> 缺少 expiredRefreshFun 配置，超时刷新调用失败，请添加 expiredRefreshFun 属性 "
      );
    }
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-table-new/stores/table.js